import { IQueryConditionHandler } from './iquerycondition.handler';
import { QueryCondition, SingleDateValue } from '@farris/component-querycondition';
import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';
import { format, addDays, addWeeks, addMonths, addYears, startOfMonth, endOfMonth, startOfYear, endOfYear, startOfWeek, endOfWeek, getDay } from 'date-fns';
/**
 * @param dateValue
 * @param dtvFormat
 */
function getDate(dateValue, dtvFormat) {
  let today = new Date();
  // today.toLocaleString()
  let result = [];
  // é¦åå¤æ­åªäºæ¯åä¸ªæ¥æï¼ä½¿ç¨equalå­å¥ä¸ä¸ªæ¥æå³å¯
  if (dateValue.isFirstDay || dateValue.isLastDay) {
    const switchValue = dateValue.dateType + '-' + (dateValue.isFirstDay ? 'first' : 'last');
    switch (switchValue) {
      case 'week-first':
        if (getDay(today) === 0) {
          today = addDays(today, -1);
        }
        result.push(addDays(startOfWeek(today), 1));
        break;
      case 'week-last':
        if (getDay(today) === 0) {
          today = addDays(today, -1);
        }
        result.push(addDays(endOfWeek(today), 1));
        break;
      case 'month-first':
        result.push(startOfMonth(today));
        break;
      case 'month-last':
        result.push(endOfMonth(today));
        break;
      case 'year-first':
        result.push(startOfYear(today));
        break;
      case 'year-last':
        result.push(endOfYear(today));
        break;
      default:
        result.push(today);
    }
  } else if (dateValue.dateType === 'day' && dateValue.period === 'present') {
    // ä»å¤©
    result.push(today);
  } else if (dateValue.dateType === 'day' && dateValue.count === 1) {
    // æ¨å¤©ãæå¤©
    const _date = addDays(today, dateValue.period === 'future' ? 1 : -1);
    result.push(_date);
  } else if (dateValue.period === 'present') {
    // æ¬å¨ãæ¬æãæ¬å¹´
    switch (dateValue.dateType) {
      case 'week':
        result.push(startOfWeek(today), endOfWeek(today));
        break;
      case 'month':
        result.push(startOfMonth(today), endOfMonth(today));
        break;
      case 'year':
        result.push(startOfYear(today), endOfYear(today));
        break;
      default:
        result.push(today);
    }
  } else {
    const switchValue = dateValue.dateType + '-' + dateValue.period;
    switch (switchValue) {
      case 'day-previous':
        result.push(addDays(today, dateValue.count * -1), addDays(today, -1));
        break;
      case 'day-future':
        result.push(addDays(today, 1), addDays(today, dateValue.count));
        break;
      case 'week-previous':
        result.push(addWeeks(today, dateValue.count * -1), addDays(today, -1));
        break;
      case 'week-future':
        result.push(addDays(today, 1), addWeeks(today, dateValue.count));
        break;
      case 'month-previous':
        result.push(addMonths(today, dateValue.count * -1), addDays(today, -1));
        break;
      case 'month-future':
        result.push(addDays(today, 1), addMonths(today, dateValue.count));
        break;
      case 'year-previous':
        result.push(addYears(today, dateValue.count * -1), addDays(today, -1));
        break;
      case 'year-future':
        result.push(addDays(today, 1), addYears(today, dateValue.count));
        break;
      default:
        result.push(today);
    }
  }

  result = result.map((item) => format(item, dtvFormat.returnFormat || 'yyyy-MM-dd'));
  return result;
};
export class SingleDateHandler implements IQueryConditionHandler {
  convert(qc: QueryCondition) {
    const arr = [];
    const dtv = (qc.value as SingleDateValue);
    if (typeof(dtv.dateValue) !== 'string') {
      const _dateValue = getDate(dtv.dateValue, qc.control);
      _dateValue.length === 1 && arr.push({
        'FilterField': qc.fieldCode,
        'Compare': qc.compareType ? CompareType[qc.compareType] : CompareType.Equal,
        'Value': _dateValue[0],
        'Relation': qc.relation ? RelationType[qc.relation] : RelationType.And, // and undefined
        'Expresstype': ValueType.Value,
        'Lbracket': qc.Lbracket || null,
        'Rbracket': qc.Rbracket || null
      });
      _dateValue.length === 2 && arr.push({
        'FilterField': qc.fieldCode,
        'Compare': CompareType.GreaterOrEqual, // GreaterOrEqual
        'Value': _dateValue[0],
        'Relation': RelationType.And, // and
        'Expresstype': ValueType.Value,
        'Lbracket': qc.Lbracket ? (qc.Lbracket + '(') :'('
      }, {
        'FilterField': qc.fieldCode,
        'Compare': CompareType.LessOrEqual, // LessOrEqual
        'Value': _dateValue[1],
        'Relation': RelationType.And, // and
        'Expresstype': ValueType.Value,
        'Rbracket': qc.Rbracket ? (qc.Rbracket + ')') : ')'
      });
    } else {
      arr.push({
        'FilterField': qc.fieldCode,
        'Compare': (qc.compareType || qc.compareType === 0) ? qc.compareType : CompareType.Equal,
        'Value': dtv.dateValue,
        'Relation': (qc.relation || qc.relation === 0) ? qc.relation : RelationType.And, // and undefined
        'Expresstype': ValueType.Value,
        'Lbracket': qc.Lbracket || null,
        'Rbracket': qc.Rbracket || null
      });
    }
    return arr;
  }
}
